import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function MasalaChai() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 20px 40px 20px",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            Masala Chai
          </h1>
          <span className="season-badge season-winter" style={{ marginBottom: 24 }}>❄️ Best in Winter</span>
          <ImageWithFallback
            src="/masala_tea.png"
            alt="Masala Chai"
            className="recipe-image-anim"
            style={{
              width: 400,
              height: 300,
              objectFit: "cover",
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 32,
            }}
          />
          <div
            style={{
              maxWidth: 800,
              fontSize: "1.1rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Ingredients:
            </h2>
            <ul className="ingredient-list" style={{ marginBottom: 24, paddingLeft: 20 }}>
              <li>2 cups water</li>
              <li>1 cup milk</li>
              <li>2 tsp loose black tea leaves (or 2 tea bags)</li>
              <li>2-3 tbsp sugar (adjust to taste)</li>
              <li>4-5 green cardamom pods, crushed</li>
              <li>1-inch fresh ginger, crushed or grated</li>
              <li>4-5 black peppercorns</li>
              <li>2-3 cloves</li>
              <li>1 small cinnamon stick</li>
              <li>1/4 tsp fennel seeds (optional)</li>
              <li>Pinch of nutmeg (optional)</li>
            </ul>

            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Instructions:
            </h2>
            <ol className="instructions-list" style={{ paddingLeft: 20 }}>
              <li style={{ marginBottom: 12 }}>
                <strong>Prepare spices:</strong> Crush the cardamom pods, ginger, and peppercorns lightly using a mortar and pestle or the back of a spoon.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Boil water with spices:</strong> In a saucepan, add water, crushed ginger, cardamom, black peppercorns, cloves, and cinnamon stick. Bring to a boil.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Simmer:</strong> Once boiling, reduce heat to medium-low and let the spices simmer for 2-3 minutes to release their flavors.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add tea leaves:</strong> Add the black tea leaves (or tea bags) to the simmering water. Let it steep for 2-3 minutes until the water turns a deep brown color.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add milk:</strong> Pour in the milk and stir. Bring the mixture back to a boil, watching carefully to prevent it from boiling over.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add sugar:</strong> Add sugar according to your taste preference. Stir well.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Boil again:</strong> Let the chai come to a rolling boil. Reduce heat and let it simmer for another 2-3 minutes for a stronger flavor.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Strain and serve:</strong> Strain the chai through a fine mesh strainer into cups. Serve hot immediately.
              </li>
            </ol>

            <div
              className="chef-tips-box"
              style={{
                background: "#f8f9fa",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips:
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Fresh ginger and whole spices give the best flavor</li>
                <li>Crushing spices before adding releases more aroma</li>
                <li>Adjust milk-to-water ratio based on preference (more milk = creamier)</li>
                <li>Don't over-boil after adding milk to prevent skin formation</li>
                <li>For stronger tea, increase steeping time or add more tea leaves</li>
                <li>Serve with biscuits or samosas for an authentic Indian tea experience</li>
              </ul>
            </div>

            <div
              className="health-benefits-box"
              style={{
                background: "#eef9f0",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Ginger and black pepper can aid digestion and help settle a mild cold or cough.</li>
                <li>Cardamom and cloves have antioxidant properties and freshen breath naturally.</li>
                <li>Black tea contains polyphenols linked to heart and gut health in moderation.</li>
                <li>The warming spice blend is traditionally used to soothe sore throats in cold weather.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default MasalaChai;